import { axios, AxiosResponse } from '~/modules'
import { IFetchMedicalNote, IFetchMedicalNotesOfSurgery, IMedicalNote } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchMedicalNote = async (params: IFetchMedicalNote): Promise<IMedicalNote> => {
  const { pathParams } = params

  const response = await axios.get(`${hstoryAPI}/medical-notes/${pathParams.noteId}`)
  const { data }: AxiosResponse<IMedicalNote> = response
  return data
}

export const fetchMedicalNotesOfSurgery = async (params: IFetchMedicalNotesOfSurgery): Promise<IMedicalNote[]> => {
  const { pathParams, queryParams } = params
  const objString = '?' + new URLSearchParams(queryParams).toString()

  const response = await axios.get(`${hstoryAPI}/surgeries/${pathParams.surgeryId}/medical-notes${objString}`)
  const { data }: AxiosResponse<IMedicalNote[]> = response
  return data
}
